import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=65f33cc3&scoped=true&"
import script from "./AddPatientModal.vue?vue&type=script&lang=js&"
export * from "./AddPatientModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPatientModal.vue?vue&type=style&index=0&id=65f33cc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f33cc3",
  null
  
)

export default component.exports